/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ValueListBox from './ValueListBox';
import NativeValueListBox from './NativeValueListBox';

@inject('windowStore')
@observer
export class FiltersList extends Component {
  render() {
    const { windowStore } = this.props;
    return (
      <React.Fragment>
        {(windowStore.isOnMobile)
          ? (<NativeValueListBox {...this.props} />)
          : (<ValueListBox {...this.props} />)}
      </React.Fragment>
    );
  }
}

export default FiltersList;



// WEBPACK FOOTER //
// ./src/blocks/FiltersList/index.jsx